<template>
  <div class="extents-panel">
    <div class="extents-label">EXTENT</div>
    <div class="extents-row" id="extentContainer">
      <div
        v-for="(extent, index) in extents"
        :key="extent.id"
        :id="'Extent' + index"
        class="extent-card"
        :class="{ 'extent-card--active': extent.extent_description === selectedExtent, 'extent-card--focused': index === currentIndex && extent.extent_description !== selectedExtent }"
        @click="extent.extent_description !== selectedExtent && changeExtent(extent)"
      >
        <img :src="getExtentImg(extent.extent_description)" class="extent-img" />
        <span class="extent-name">{{ extent.extent_description }}</span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.extents-panel {
  padding: 8px 10px 10px;
  min-width: 200px;
}

.extents-label {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.65rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin-bottom: 8px;
}

.extents-row {
  display: flex;
  flex-direction: row;
  gap: 6px;
  overflow-x: auto;
  padding-bottom: 2px;
}

.extents-row::-webkit-scrollbar {
  height: 3px;
}
.extents-row::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
}
.extents-row::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.25);
  border-radius: 2px;
}

.extent-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  padding: 6px 8px;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 0.25rem;
  cursor: pointer;
  transition: background 0.12s ease, border-color 0.12s ease;
  flex-shrink: 0;
  min-width: 72px;
}

.extent-card:hover:not(.extent-card--active) {
  background: rgba(255, 255, 255, 0.14);
  border-color: rgba(255, 255, 255, 0.25);
}

.extent-card--active {
  background: rgba(0, 123, 255, 0.25);
  border-color: #007bff;
  cursor: default;
}

.extent-card--focused {
  border-color: rgba(255, 255, 255, 0.4);
}

.extent-img {
  width: 56px;
  height: 44px;
  object-fit: contain;
}

.extent-name {
  color: #fff;
  font-size: 0.65rem;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  user-select: none;
}
</style>

<script>
import axios from 'axios'
import {get as projGet, transformExtent, transform} from 'ol/proj'
import View from 'ol/View'
// import EuropeSVG from '../../../assets/extents/Europe.svg'
// import JapanSVG from '../../../assets/extents/Japan.svg'
// import MiddleEastSVG from '../../../assets/extents/MiddleEast.svg'
// import NorthAmericaSVG from '../../../assets/extents/NorthAmerica.svg'
// import SouthKoreaSVG from '../../../assets/extents/SouthKorea.svg'
export default {
  name: 'MMP_CollapsedExtents',
  props: ['expanded', 'map', 'selectedExtent', 'userOrg', 'baseMapsOpen'],
  data() {
    return {
      extents: [],
      EuropeSVG: require('../../../assets/extents/Europe.svg'),
      JapanSVG: require('../../../assets/extents/Japan.svg'),
      MiddleEastSVG: require('../../../assets/extents/MiddleEast.svg'),
      NorthAmericaSVG: require('../../../assets/extents/NorthAmerica.svg'),
      SouthKoreaSVG: require('../../../assets/extents/SouthKorea.svg'),
      currentIndex: 0
    }
  },
  methods: {
    changeExtent(selectedExtent) {
      let extentValues = []
      let extentCenter = []
      /* Need to convert the string into array of numbers
      for passing to the transformExtent function. */
      selectedExtent.extent.split(',').forEach(element => {
        extentValues.push(element)
      })
      selectedExtent.extent_center.split(',').forEach(element => {
        extentCenter.push(element)
      })
      
      let view = new View({
        extent: new transformExtent(
          extentValues,
          new projGet('EPSG:4326'),
          new projGet('EPSG:3857')
        ),
        center: new transform(
          extentCenter,
          new projGet('EPSG:4326'),
          new projGet('EPSG:3857')
        ),
        constrainOnlyCenter: true,
        zoom: 5,
        minZoom: 3,
        multiWorld: true
      })
      this.$emit('extentChanged', {
        selectedExtent: selectedExtent.extent_description,
        view: view
      })
      // this.$emit('click')
    },
    getExtents() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/users/getExtents', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              company_id: this.userOrg
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('getExtents API Call Error: ' + content.errors)
            } else {
              this.extents = content
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    getExtentsWithoutSelectedExtent() {
      return this.extents.filter(ext => {
        return ext.extent_description != this.selectedExtent
      })
    },
    getExtentImg(extent) {
      let extentImg
      switch (extent) {
        case 'Europe':
          extentImg = this.EuropeSVG
          break
        case 'Japan':
          extentImg = this.JapanSVG
          break
        case 'Middle East':
          extentImg = this.MiddleEastSVG
          break
        case 'Kuwait': 
          extentImg = this.MiddleEastSVG
          break
        case 'South Korea':
          extentImg = this.SouthKoreaSVG
          break
        case 'Saudi Arabia':
          extentImg = this.MiddleEastSVG
          break
        case 'North America':
        default:
          extentImg = this.NorthAmericaSVG
          break
      }
      return extentImg
    },
    highlightCurrentIndex(index) {
      return index == this.currentIndex ? 'b-img-highlight' : ''
    },
    scrollToImg(id) {
      this.$nextTick(() => {
        let layer = document.getElementById(id) // get the layer element by its ID declared above
        if (layer) {
          layer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      })
    },
    keyDownHandler(event) {
      if (['input', 'b-form-textarea', 'b-form-input', 'textarea'].includes(event.target.tagName.toLowerCase())) {
        return;
      }
      if (event.key == 'ArrowLeft' && this.currentIndex > 0) {
        this.currentIndex--
        this.scrollToImg('Extent' + this.currentIndex)
      } else if (event.key == 'ArrowRight' && this.currentIndex < this.extents.length - 1) {
        this.currentIndex++
        this.scrollToImg('Extent' + this.currentIndex)
      } else if (event.key == 'Enter') {
        const extent = this.extents[this.currentIndex]
        if (extent && extent.extent_description !== this.selectedExtent) {
          this.changeExtent(extent)
        }
      }
    },
    removeIteratorListener() {
      window.removeEventListener('keydown', this.keyDownHandler)
    },
    addIteratorListener() {
      window.addEventListener('keydown', this.keyDownHandler)
    }
  },
  mounted() {
    if (this.userOrg) {
      this.getExtents()
    }
    window.addEventListener('wheel', e => {
      let item = document.getElementById('extentContainer')
      let scrollDelta = 35
      let node = e.target
      while (node) {
        if (node == item) {
          item.scrollLeft += e.deltaY > 0 ? scrollDelta : -scrollDelta
          node = false
        } else {
          node = node.parentNode
        }
      }
    })

    window.addEventListener('keydown', (event) => {
      if (['input', 'b-form-textarea', 'b-form-input', 'textarea'].includes(event.target.tagName.toLowerCase())) {
        return;
      }
      if (event.key == 'E' || event.key == 'e') {
        this.$emit('click')
      }
    })

    if (this.expanded) {
      window.addEventListener('keydown', this.keyDownHandler)
    }
  },
  watch: {
    userOrg: function () {
      this.getExtents()
    },
    expanded: function (newValue) {
      this.$emit('extentsExpandChange', this.expanded)
      if (newValue) {
        this.addIteratorListener()
      } else {
        this.removeIteratorListener()
      }
      this.currentIndex = 0
      this.scrollToImg('Extent' + 0)
    },
    baseMapsOpen: function (newValue) {
      if (newValue) {
        this.removeIteratorListener()
      } else if (this.expanded) {
        this.addIteratorListener()
      } 
    }
  }
}
</script>
